import { useForm, Head, usePage } from '@inertiajs/react'
import { FormEvent } from 'react'
import '../Dashboard/Dashboard.css'

interface Props {
  errors?: Record<string, string>
}

export default function SignIn({ errors }: Props) {
  const { flash } = usePage().props as any
  const { data, setData, post, processing, transform } = useForm({
    email: '',
    password: '',
    remember_me: false,
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    transform((data) => ({ user: data }))
    post('/users/sign_in')
  }

  return (
    <>
      <Head title="Sign In - FillMyCalendar" />
      <div style={{ position: 'relative', width: '100vw', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          position: 'absolute', top: '10%', left: '20%', width: '400px', height: '400px',
          background: 'radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, transparent 70%)',
          borderRadius: '50%', zIndex: -1, pointerEvents: 'none'
        }} />

        <div className="glass-panel" style={{ width: '100%', maxWidth: '500px', padding: '40px', animation: 'fadeIn 0.4s ease' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
            <a href="/" className="btn-icon" style={{ textDecoration: 'none' }}><i className="fa-solid fa-arrow-left"></i></a>
            <div style={{ fontWeight: 700, fontSize: '1.2rem', letterSpacing: '-0.02em', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div className="logo-icon" style={{ width: '24px', height: '24px', fontSize: '12px' }}><i className="fa-solid fa-bolt"></i></div>
              FillMyCalendar
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '24px' }}>Sign In</h2>

            {flash?.alert && (
              <div style={{ padding: '12px', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.3)', color: 'var(--danger)', borderRadius: 'var(--radius-sm)', marginBottom: '16px', fontSize: '0.85rem' }}>
                <i className="fa-solid fa-circle-exclamation" style={{ marginRight: '8px' }}></i> {flash.alert}
              </div>
            )}

            {errors?.email && (
              <div style={{ padding: '12px', background: 'rgba(239, 68, 68, 0.1)', color: 'var(--danger)', borderRadius: 'var(--radius-sm)', marginBottom: '16px', fontSize: '0.85rem' }}>
                {errors.email}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                id="email"
                type="email"
                className="form-control"
                placeholder="name@company.com"
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                required
                aria-invalid={!!errors?.email}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label htmlFor="password" className="form-label">Password</label>
              <input
                id="password"
                type="password"
                className="form-control"
                placeholder="••••••••"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                required
                aria-invalid={!!errors?.password}
              />
              {errors?.password && <span style={{ color: 'var(--danger)', fontSize: '0.8rem', marginTop: '4px', display: 'block' }}>{errors.password}</span>}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '32px' }}>
              <input
                id="remember_me"
                type="checkbox"
                checked={data.remember_me}
                onChange={(e) => setData('remember_me', e.target.checked)}
                style={{ accentColor: 'var(--accent-1)', width: '16px', height: '16px' }}
              />
              <label htmlFor="remember_me" style={{ color: 'var(--text-2)', fontSize: '0.85rem', cursor: 'pointer' }}>
                Remember my device
              </label>
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '12px', fontSize: '1rem', fontWeight: 600 }} disabled={processing}>
              {processing ? <><i className="fa-solid fa-spinner fa-spin"></i> Authenticating...</> : 'Sign In to Dashboard'}
            </button>
          </form>

          <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '0.85rem', color: 'var(--text-3)' }}>
            Don't have an account? <a href="/users/sign_up" style={{ color: 'var(--accent-1)', textDecoration: 'none', fontWeight: 600 }}>Sign Up</a>
          </div>
        </div>
      </div>
    </>
  )
}
